import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SIZES } from './constants';
import classes from './index.module.scss';

/**
 * @deprecated Please use Switch from @fiverr-private/forms instead.
 */
const Switch = forwardRef(({
    className: customClassName,
    labelClassName,
    size,
    disabled,
    children,
    ...rest
}, ref) => {
    const className = classnames(
        classes.switch,
        [classes[`size-${size}`]],
        {
            [classes.disabled]: disabled
        },
        customClassName,
    );
    const labelClassNames = classnames(
        classes.text,
        labelClassName
    );
    const inputProps = Object.assign({
        type: 'checkbox',
        ref,
        disabled
    }, rest);

    return (
        <label className={className}>
            <input {...inputProps}/>
            <span className={classes.toggle}/>
            {children && <span className={labelClassNames}>{children}</span>}
        </label>
    );
});

Switch.displayName = 'Switch';

Switch.propTypes = {
    /**
     * The component's size. <br>Supported options are exposed through the static `SIZES` property
     */
    size: PropTypes.oneOf(Object.values(SIZES)),
    /**
     * Whether or not the switch is disabled.
     * A disabled switch is not clickable, or hoverable.
     */
    disabled: PropTypes.bool,
    /**
     * Provides a React `ref` access to the component's inner `<input>` element.
     */
    ref: PropTypes.func,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: PropTypes.string,
    /**
     * Custom classes you wish to pass to the label.
     */
    labelClassName: PropTypes.string,
    /**
     * Any node that can be rendered as a label.
     */
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

Switch.defaultProps = {
    size: SIZES.MEDIUM,
    disabled: false
};

Object.assign(Switch, { SIZES });

export default Switch;
